<template>
  <div class="community-profile-popover p-2">
    <div class="d-flex align-items-center mb-4">
      <img v-if="user.picture" :src="user.picture" class="user-picture mr-3" />

      <div class="flex-fill">
        <div class="d-flex mb-3 align-items-center">
          <h3 class="mb-0 flex-fill">
            {{ user.name }}
          </h3>
          <a
            v-if="user.phone"
            :href="`https://api.whatsapp.com/send?phone=${user.phone}`"
            target="_blank"
            class="btn btn-success rounded-pill px-4"
          >
            <i class="fab fa-whatsapp fa-lg"></i> WHATSAPP
          </a>
        </div>

        <table>
          <tr>
            <td>
              <img class="img-icon" src="@/assets/images/small-logo.svg" />
            </td>
            <td>Entrou em {{ createdAt }}</td>
          </tr>
          <tr v-if="user.temper">
            <td><img class="img-icon" :src="temperImage" /></td>
            <td>{{ temperName }}</td>
          </tr>
          <tr v-if="user.occupation">
            <td><i class="fas fa-fw fa-briefcase"></i></td>
            <td>{{ user.occupation }}</td>
          </tr>
          <tr
            v-if="
              user.localization &&
                user.localization.city &&
                user.localization.state
            "
          >
            <td><i class="fas fa-fw fa-map-marker-alt"></i></td>
            <td>
              Mora em {{ user.localization.city }},
              {{ user.localization.state }}
            </td>
          </tr>
        </table>
      </div>
    </div>

    <nav-tab
      v-model="nav"
      :comments="user.count_comment"
      :topics="user.count_topic"
    />

    <div v-if="nav === 'bio'">
      <template v-if="user.bio">{{ user.biography }}</template>
      <div v-else class="text-secondary small">
        Este usário ainda não cadastrou uma descrição.
      </div>
    </div>

    <action-dispatcher
      v-if="nav === 'topics'"
      action="community/getUserTopics"
      :parameters="user.id"
    >
      <router-link
        v-for="comment in userTopics"
        :key="-comment.id"
        :to="{ name: 'community-topic', params: { id: comment.id } }"
        class="text-light d-flex align-items-center text-decoration-none my-3"
      >
        <img v-if="comment.picture" class="mr-2" :src="comment.picture" />
        <div>
          <small class="text-secondary">{{ time(comment) }}</small>
          <h6 class="mb-0">{{ comment.title }}</h6>
          <small>
            {{ comment.count }} resposta{{ comment.count === 1 ? "" : "s" }}
            <span class="mx-1">·</span>
            {{ comment.like }} curtida{{ comment.like === 1 ? "" : "s" }}
          </small>
        </div>
      </router-link>
    </action-dispatcher>
  </div>
</template>

<script>
import NavTab from "./NavTab";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { mapState } from "vuex";

dayjs.extend(relativeTime);
dayjs.locale("pt");

export default {
  components: { NavTab },
  props: {
    user: Object
  },
  data() {
    return {
      nav: "bio"
    };
  },
  computed: {
    ...mapState("community", ["userTopics"]),
    temperImage() {
      const temper = this.user.temper || "todos";
      return require(`../../assets/images/temperamentos/${temper}.svg`);
    },
    temperName() {
      return {
        colerico: "Colérico",
        melancolico: "Melancólico",
        fleumatico: "Fleumático",
        sanguineo: "Sanguíneo"
      }[this.user.temper];
    },
    createdAt() {
      const dateString = this.user.created_at;
      return dayjs(dateString)
        .locale("pt")
        .format("MMMM [de] YYYY");
    }
  },
  methods: {
    time(comment) {
      return dayjs().to(dayjs(comment.created_at).add(3, "hour"));
    }
  }
};
</script>

<style lang="scss" scoped>
.community-profile-popover {
  .user-picture {
    max-height: 160px;
    max-width: 160px;
    min-height: 160px;
    min-width: 160px;
    border-radius: 160px;
  }

  h6 {
    font-size: 18px;
    font-weight: 500;
  }

  i {
    margin-right: 4px;
  }

  .img-icon {
    height: 20px;
    width: 17px;
    object-fit: contain;
    margin-right: 4px;
  }

  hr {
    border-color: rgba(255, 255, 255, 0.2);
  }

  .btn {
    font-size: 14px;
    font-weight: 500;
  }

  table {
    color: #bbb;

    i {
      color: white;
    }
  }

  a {
    img {
      max-width: 56px;
      max-height: 56px;
      min-width: 56px;
      min-height: 56px;
      object-fit: cover;
    }
  }
}
</style>
